//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
    componentNameToTemplate,
    hasAllFeatures,
    lazyLoadModule,
    NavGroup,
    StateFactory,
} from 'app/initialization/routing/stateHelpers';

export function routingRules() {
    // No routing rules
}

export const states = {
  conversations: StateFactory({
    url: '/conversations',
    template: componentNameToTemplate('conversationsPage'),
    data: {
      title: 'Conversations',
      navGroup: NavGroup.HOME,
      hasAccess: () => hasAllFeatures('engage'),
    },
    resolve: {
      ...lazyLoadModule(
                'curalate.conversations',
                () => import('app/conversations/conversations.app'),
            ),
    },
  }),
};
